// fixed-btn in-view.js
(function() {
  var $target = document.getElementById('js-fixedBtn');
  if ($target != null) {
    // console.log('aaaaaaa');
    inView.offset({
      bottom: 80
    });
    inView('#anchor-fixed-btn').on('enter', function() {
      if ($target.classList.contains('is-active')) {
        $target.classList.remove('is-active');
      } else {
        $target.classList.add('is-active');
      }
      // $target.classList.remove('is-active');
    });
    inView('#area-concept').on('enter', function() {
      $target.classList.remove('is-active');
      console.log('hogeeg');
    });

  }
}());
